export default "__VITE_ASSET__Bvu0XaO9__"